import React from 'react'
import { URL_SRV_ARIZTIA } from '../../router/Url'

export const WithDateGetMachines = ({FechaInicio, FechaFinal, empresa}) => {
    // console.log(FechaInicio, FechaFinal, empresa)
    return new Promise(async (resolve, reject) => {
        let query = await fetch(URL_SRV_ARIZTIA+'machinesbydaterange',{
          method: 'POST',
          headers: {
            'authorization': "paico2021",
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            "FECHA_INICIO":FechaInicio,
            "FECHA_FIN":FechaFinal,
            "EMPRESA":empresa
          })
        })
        let responsito = await query.json();
        // console.log("ITEMS",responsito.body)
        if(responsito.success){
           resolve(responsito.body)
        }else{
            // Alert.alert('Medidores',responsito.msg)
            resolve([])
            return
          // resolve(responsito.data.body)
        }
    })
}
